import { combineReducers } from '@reduxjs/toolkit';
import { api } from '@/lib/api';
import { authReducer } from '@/features/auth';
import { storesUiReducer } from '@/features/stores';
import { inboxUiReducer } from '@/features/inbox';
import { contactsUiReducer } from '@/features/contacts';
import { dashboardUiReducer } from '@/features/dashboard';
import { queueUiReducer } from '@/features/queue';
import { managementUiReducer } from '@/features/management';
import { metricsUiReducer } from '@/features/metrics';
import { goalsUiReducer } from '@/features/goals';
import { crmUiReducer } from '@/features/crm';
import { campanhasUiReducer } from '@/features/campanhas';
import { notificationsReducer } from '@/features/notifications';

export const rootReducer = combineReducers({
  auth: authReducer,
  storesUi: storesUiReducer,
  inboxUi: inboxUiReducer,
  contactsUi: contactsUiReducer,
  dashboardUi: dashboardUiReducer,
  queueUi: queueUiReducer,
  managementUi: managementUiReducer,
  metricsUi: metricsUiReducer,
  goalsUi: goalsUiReducer,
  crmUi: crmUiReducer,
  campanhasUi: campanhasUiReducer,
  notifications: notificationsReducer,
  [api.reducerPath]: api.reducer,
});

export type RootStateShape = ReturnType<typeof rootReducer>;
